import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import ContextMenu, {
  SimpleMenuItem,
} from 'fe-design-base/molecules/ContextMenu';
import IconButton from 'fe-design-base/molecules/IconButton';

import { selectSelectedSort, setSelectedSort } from 'features/messenger/slice';

import Tabs from 'components/Tabs';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

import MessengerHeaderMenu from './MessengerHeaderMenu';

const { cxEl } = cxHelpers('MessengerView');

const MessengerHeader = ({
  currentTab,
  handleTabChange,
  tabs,
  handleClose,
  repackagingEnabled,
  showMessengerScrim,
  menuOpen,
  handleMenuClose,
  toggleMenuOpen,
  showMenu,
  iconSize = 'medium',
}) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const selectedSort = useSelector(selectSelectedSort);

  const handleCloseContextMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSortChange = useCallback(
    newSort => () => {
      const button_text =
        newSort === 'recent'
          ? toI18n('messaging.channel_list.recent')
          : toI18n('messaging.channel_list.unread');
      trackUxEvent({
        productArea: PRODUCT_AREAS.MESSAGES,
        eventCategory: EVENT_CATEGORIES.CONVERSATION_LIST,
        eventAction: EVENT_ACTIONS.BUTTON_CLICKED,
        properties: { button_text },
      });
      dispatch(setSelectedSort(newSort));
      handleCloseContextMenu();
    },
    [dispatch, handleCloseContextMenu]
  );

  const handleClickTrigger = useCallback(event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  return (
    <Box spacebetween vcenter className={cxEl('tabs-container')} pr={24}>
      <Tabs value={currentTab} onChange={handleTabChange} tabs={tabs} />

      <Box row vcenter>
        {currentTab === 'team' && (
          <IconButton
            icon="Sort"
            color="primary700"
            size={iconSize}
            onClick={handleClickTrigger}
            label={toI18n('messaging.actions.sort')}
          />
        )}

        {currentTab === 'team' && showMenu && (
          <MessengerHeaderMenu
            repackagingEnabled={repackagingEnabled}
            showMessengerScrim={showMessengerScrim}
            menuOpen={menuOpen}
            handleMenuClose={handleMenuClose}
            toggleMenuOpen={toggleMenuOpen}
          />
        )}

        <IconButton
          icon="Close"
          color="primary700"
          size={iconSize}
          onClick={handleClose}
          label={toI18n('actions.close')}
        />
      </Box>

      <ContextMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseContextMenu}
        onClickAway={handleCloseContextMenu}
      >
        <SimpleMenuItem
          onClick={handleSortChange('recent')}
          label={toI18n('messaging.channel_list.recent')}
          iconName={selectedSort === 'recent' ? 'Success' : ''}
        />

        <SimpleMenuItem
          onClick={handleSortChange('unread')}
          label={toI18n('messaging.channel_list.unread')}
          iconName={selectedSort === 'unread' ? 'Success' : ''}
        />
      </ContextMenu>
    </Box>
  );
};

export default MessengerHeader;
